import { Pipe, PipeTransform } from '@angular/core';
import { PriceRegulationType } from 'src/app/features/prices/price-regulations/price-regulation';

@Pipe({
  name: 'translatePriceRegulationType',
})
export class TranslatePriceRegulationTypePipe implements PipeTransform {
  transform(type: PriceRegulationType | null | undefined): string {
    if (type === PriceRegulationType.Discount) {
      return 'Rabat (kr./kWh)';
    }

    if (type === PriceRegulationType.SupplementOverride) {
      return 'Fast pristillæg';
    }

    return '-';
  }
}
